import media from "css-in-js-media";
import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import { useMediaQuery } from "usehooks-ts";
import Logo from "../../images/icons/logo.svg";
import { Container } from "../Row";
import { DesktopHeader } from "./DesktopHeader";
import { MobileHeader } from "./MobileHeader";

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  background: var(--colour-dark-grey);
  z-index: 1000;
  min-height: 70px;

  ${media(">desktop")} {
    position: sticky;
    top: 0;
    min-height: 90px;
  }

  .logo {
    fill: var(--colour-yellow);
    width: 46px;
    height: 46px;
  }
`;

const StyledContainer = styled(Container)`
  max-width: var(--layout-max-content-width);
  margin: 0 auto;
  width: 100%;
  padding-left: 1rem;
`;

export interface SubNavColumn {
  _key: string;
  title: string;
  links: {
    _key: string;
    title: string;
    variant: string;
    internalLink: {
      slug: {
        current: string;
      };
    };
    externalLink: string;
    customLink: string;
  }[];
}

export interface SubNav {
  title?: string;
  description?: string;
  image?: {
    asset: {
      gatsbyImageData: any;
      altText: string;
    };
  };
  columns?: SubNavColumn[];
}

export interface NavItem {
  _key: string;
  title: string;
  subNavigation?: SubNav;
  internalLink: {
    slug: {
      current: string;
    };
  };
  externalLink: string;
  customLink: string;
}

export interface HeaderProps {
  navItems: NavItem[];
}

export interface NavItemProps {
  title: string;
  _key: string;
  to: string;
  activeTrigger: HTMLElement;
  setActiveTrigger: (node: HTMLElement) => void;
  value: string;
  subNavigation?: SubNav;
}

export const Header: React.FC<HeaderProps> = ({ navItems }) => {
  const isMobile = useMediaQuery("(max-width: 960px)");

  const [hasMounted, setHasMounted] = React.useState(false);

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return (
      <StyledHeader>
        <StyledContainer>
          <Link to="/" aria-label="Answer">
            <Logo className="logo" />
          </Link>
        </StyledContainer>
      </StyledHeader>
    );
  }

  return (
    <StyledHeader>
      {isMobile ? <MobileHeader navItems={navItems} /> : <DesktopHeader navItems={navItems} />}
    </StyledHeader>
  );
};
